import { useHistory } from "react-router-dom"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import Applications from "./applications"

const initialServices = [
  { name: "Request for ToRs", key: "request_for_tor_applications", count: 10 },
  { name: "Report Under Review", key: "report_under_review", count: 5 },
  { name: "Pending Report Submission", key: "report_submission_pending", count: 8 },
  { name: "Waiting Certificate", key: "waiting_certificate", count: 3 },
  { name: "Approved Certificate", key: "approved_applications", count: 12 },
];

import EnvironmentalAudit from "services/EnvironmentalAudit.service"
const user = JSON.parse(localStorage.getItem("authUser"))

const appService = new EnvironmentalAudit(user)

const EnvAuditMenu = () => {
  const history = useHistory()
  const [mounted, setmounted] = useState(false)
  const [applications, setapplications] = useState()
  const [serviceName, setserviceName] = useState("")
  const [services, setServices] = useState(initialServices);


  useEffect(() => {
    fetchStatistics()
  }, [])

  const handleClick = serviceName => {
    setserviceName(serviceName)
    if (serviceName == "Request for ToRs") {
        getToRs()
    } else if (serviceName === "Report Under Review") {
        getReportsUnderReview()
    } else if (serviceName === "Pending Report Submission") {
        getPendingReportSubmissions()
    } else if (serviceName === "Waiting Certificate") {
        getWaitingCertificates()
    } else if (serviceName === "Approved Certificate") {
        getApprovedApplications()
    }
   
  }

  const getToRs = () => {
    appService.getTORApplications().then(response => {
      if (response.status) {
        setapplications({data: response.data})
        setmounted(true)
      }
    })
  }

  const getReportsUnderReview = () => {
    appService.getReportsUnderReview().then(response => {
      if (response.status) {
        setapplications({data: response.data})
        setmounted(true)
      }
    })
  }

  const getPendingReportSubmissions = () => {
    appService.getPendingReportSubmissions().then(response => {
      if (response.status) {
        setapplications({data: response.data})
        setmounted(true)
      }
    })
  }

  const getWaitingCertificates = () => {
    appService.getWaitingCertificates().then(response => {
      if (response.status) {
        setapplications({data: response.data})
        setmounted(true)
      }
    })
  }

  const getApprovedApplications = () => {
    appService.getApprovedApplications().then(response => {
      if (response.status) {
        setapplications({data: response.data})
        setmounted(true)
      }
    })
  }


  const fetchStatistics = () => {
    appService.getStatistics().then(response => {
      if (response.status) {
        console.log("stats", response)
        const data = response.data;

        // Update services with the latest counts
        const updatedServices = initialServices.map(service => ({
            ...service,
            count: data[service.key] ?? 0, // Default to 0 if key is missing
        }));

        setServices(updatedServices);
      }
    })
  }



  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Environmental Audit Menu | REMA</title>
        </MetaTags>
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={12}>
                <h6 className="page-title">Env Audit Dashboard</h6>
              </Col>
            </Row>
          </div>
          <Row>
            {services.map((service, index) => (
              <Col md="4" sm="6" xs="12" key={service.name} className="mb-2">
                <Card
                  onClick={() => handleClick(service.name)}
                  className="shadow-sm cursor-pointer"
                >
                  <CardBody className="d-flex justify-content-between align-items-center">
                    <span className="font-weight-bold">{service.name}</span>
                    <span className="badge bg-primary text-white rounded-circle px-3 py-2">
                      {service.count}
                    </span>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>

          {mounted ? (
            <Row>
                <h4>Selected Service: {serviceName}</h4>
              <Applications
                data={applications}
                //   paginate={fetchApplicationsPage}
              />
            </Row>
          ) : null}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default EnvAuditMenu
